import { create } from 'zustand';

import { NavOptions } from '@/components/navigation/constants';
import { NavItemConfig, NavOption } from '@/components/navigation/types';

type NavStore = {
  accessibleNavItems: Record<string, NavItemConfig[]>;
  activeNavMenu: NavOption;
  facilityName: string | undefined;
  orgIcon: string | undefined;
  orgName: string | undefined;
  roles: string[] | undefined;
  selectedNavItemId: string | undefined;
  userName: string | undefined;
  enableFacilityMenu: boolean;
  facilitySearchQuery: string;
  userAccessIsLoading: boolean;
  expanded: boolean;
  setAccessibleNavItems: (items: NavItemConfig[]) => void;
  setActiveNavMenu: (menu: NavOption) => void;
  setFacilityName: (name: string | undefined) => void;
  setOrgIcon: (icon: string | undefined) => void;
  setOrgName: (name: string | undefined) => void;
  setRoleInfo: (roleInfo: string[] | undefined) => void;
  setSelectedNavItemId: (id: string) => void;
  setUserName: (name: string) => void;
  setEnableFacilityMenu: (enable: boolean) => void;
  setFacilitySearchQuery: (query: string) => void;
  setUserAccessIsLoading: (userAccessIsLoading: boolean) => void;
  setExpanded: (expanded: boolean) => void;
};

export const useNavStore = create<NavStore>((set) => ({
  accessibleNavItems: {},
  activeNavMenu: NavOptions.Main,
  facilityName: undefined,
  orgIcon: undefined,
  orgName: undefined,
  roles: undefined,
  selectedNavItemId: undefined,
  userName: undefined,
  enableFacilityMenu: false,
  facilitySearchQuery: '',
  userAccessIsLoading: false,
  expanded: false,
  setAccessibleNavItems: (items: NavItemConfig[]) =>
    set({
      accessibleNavItems: items.reduce(
        (acc, item) => {
          if (!acc[item.category]) {
            acc[item.category] = [];
          }
          acc[item.category].push(item);
          return acc;
        },
        {} as Record<string, NavItemConfig[]>
      ),
    }),
  setActiveNavMenu: (menu: NavOption) => set({ activeNavMenu: menu }),
  setFacilityName: (name: string | undefined) => set({ facilityName: name }),
  setOrgIcon: (icon: string | undefined) => set({ orgIcon: icon }),
  setOrgName: (name: string | undefined) => set({ orgName: name }),
  setRoleInfo: (roles: string[] | undefined) => set({ roles }),
  setSelectedNavItemId: (id: string) => set({ selectedNavItemId: id }),
  setUserName: (name: string) => set({ userName: name }),
  setEnableFacilityMenu: (enable: boolean) => set({ enableFacilityMenu: enable }),
  setFacilitySearchQuery: (query: string) => set({ facilitySearchQuery: query }),
  setUserAccessIsLoading: (userAccessIsLoading: boolean) => set({ userAccessIsLoading }),
  setExpanded: (expanded: boolean) => set({ expanded }),
}));
